import * as requestFromServer from "./PersonnelReportCrud";
import { callTypes, personnelReportSlice } from "./PersonnelReportSlice";

const {actions} = personnelReportSlice;

export const getPersonnelReport = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getPersonnelReport(queryParams)
    .then(response => {
      dispatch(actions.personnelReportFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllPersonnelReport = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllPersonnelReport(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getPersonnelTypes = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getPersonnelTypes()
    .then(response => {
      dispatch(actions.personnelTypesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const cleanPersonnelReportState = () => dispatch => {
  dispatch(actions.personnelReportStateCleaned());
}